module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"ui":{"components":{"users":{"profile":{"contact_modal":{"action":"Add more contact data","address":"Address:","company":"Company:","modal_title_html":"Address and contact data<br>of %{name}","phone":"Telephone:","send_message":"Send message","show_phone":"Show phone number","zipcode":"Zipcode:"}}}}}}}')
  delete Component.options._Ctor
}
